import React from "react";
import { Box } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import Image from "next/image";
import Logo from "public/assets/icons/logo.png";
import { Typography } from "@mui/material";
import { colors } from "src/config/colors";

const OffersListLoader: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <CircularProgress size={80} />
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "30%",
            transform: "translateX(-50%)",
          }}
        >
          <Image alt="Лого" width="45px" height="38px" src={Logo} />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          component="span"
          sx={{
            fontSize: "13px",
            whiteSpace: "nowrap",
            fontWeight: 700,
            color: colors.blue,
            textAlign: "center",
          }}
        >
          Идёт поиск предложений.
          <br />
          Обычно это занимает не более 10-15 секунд.
          <br />
          Хорошего вам дня &#128522;
        </Typography>
      </Box>
    </Box>
  );
};

export default OffersListLoader;
